// Where an invitation's game access applies, for the accept screen. The server names each geography
// (geographyName) because the invitee cannot list the game's segments yet. A raw segment id means nothing
// to the invitee, so one the server could not name shows as UNNAMED_GEOGRAPHY instead.
// No geographies on a game means the whole game.
export const WHOLE_GAME_LABEL = 'Global (whole game)';
export const UNNAMED_GEOGRAPHY = 'Unnamed geography';

/**
 * The Geographies field as one line of text (it wraps): the names for a single game, else per game,
 * e.g. "South Asia, Europe" or "Tetris: South Asia · Puzzle Quest: Global (whole game)".
 */
export const geographiesText = (rows) => {
    const names = (r) => (r.geographies.length ? r.geographies.join(', ') : WHOLE_GAME_LABEL);
    if (!rows || !rows.length) return '';
    return rows.length === 1 ? names(rows[0]) : rows.map(r => `${r.gameName}: ${names(r)}`).join(' · ');
};

/** One entry per game: its name and the names of the geographies granted on it ([] = whole game). */
export const invitationGeographies = (gameDetailsMap, gameNameOf = (id) => id) =>
    Object.entries(gameDetailsMap || {}).map(([gameId, game]) => ({
        gameId,
        gameName: game?.gameName || gameNameOf(gameId),
        geographies: Object.entries(game?.segmentDetailsMap || {})
            .map(([, geo]) => geo?.geographyName || UNNAMED_GEOGRAPHY),
    }));
